import React from "react";
import "./JobDetails.css";

// Déséchapper le HTML si besoin
function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export default function JobDetails({ job }) {
  if (!job) {
    return (
      <div className="job-details empty flex-1 p-6 flex items-center justify-center">
        Aucune offre disponible pour l'instant
      </div>
    );
  }

  const now = new Date();
  const expired = job.endDate && new Date(job.endDate) < now;
  const expiryLabel = job.endDate ? (expired ? 'Expirée le ' : 'Prend fin le ') + new Date(job.endDate).toLocaleDateString() : null;
  const depublishPlanned = !!job.depublishRequested && job.depublishAt;
  const depublishAt = depublishPlanned ? new Date(job.depublishAt) : null;
  const depublishPending = depublishPlanned && depublishAt > now;
  const depublishEta = depublishPending ? Math.max(0, depublishAt.getTime() - now.getTime()) : 0;
  const hoursLeft = depublishPending ? Math.ceil(depublishEta / (60*60*1000)) : 0;
  return (
    <div className="job-details flex-1 p-6">
      {depublishPending && (
        <div style={{background:'#fff7ed', border:'1px solid #fdba74', color:'#9a3412', padding:'8px 12px', borderRadius:8, marginBottom:10, fontSize:13}}>
          Cette offre sera temporairement indisponible sous {hoursLeft}h.
        </div>
      )}
      <div style={{display:'flex', alignItems:'center', gap:12, flexWrap:'wrap'}}>
        <h2 className="text-2xl font-bold mb-2" style={{margin:0}}>{job.title}</h2>
        {expiryLabel && (
          <span style={{fontSize:12, background: expired? '#991b1b':'#1e3a8a', color:'#fff', padding:'4px 10px', borderRadius:20}}>{expiryLabel}</span>
        )}
      </div>
      <div style={{fontSize:13, color:'#475569', marginTop:4, display:'flex', flexWrap:'wrap', gap:'14px'}}>
        {job.location && <span><strong>Lieu:</strong> {job.location}</span>}
        {job.contractType && <span><strong>Contrat:</strong> {job.contractType}</span>}
      </div>
      <div
        className="whitespace-pre-line text-sm leading-relaxed mb-6"
        style={{marginTop:8}}
        dangerouslySetInnerHTML={{
          __html: /&lt;|&gt;|&amp;/.test(job.description)
            ? decodeHtml(job.description)
            : job.description
        }}
      />
      {job.attachments && job.attachments.length > 0 && (
        <div style={{marginTop:12}}>
          <h4 style={{margin:'0 0 6px', fontSize:14}}>Pièces jointes</h4>
          <ul style={{paddingLeft:18, margin:0, fontSize:13}}>
            {job.attachments.map((a,i)=>(
              <li key={i} style={{marginBottom:4}}>
                {a.dataUrl ? <a href={a.dataUrl} download={a.name || ('fichier_'+i)} style={{color:'#1d4ed8'}}>{a.name || 'Fichier'}</a> : <span>{a.name || 'Fichier'}</span>} {a.size ? <span style={{color:'#64748b'}}>({Math.round(a.size/1024)} KB)</span>: null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
